import get from 'lodash/get'
import { ReduxState } from 'app-types'

import { SmsVerifyResponse, SigningType } from '../../../constants'
import { SmsSendResponse } from '../../../types'

export const getSmsSendResponse = (state: ReduxState): SmsSendResponse =>
  get(state, 'signing.smsSendResponse')

export const getVerificationCode = (state: ReduxState): SmsVerifyResponse =>
  get(state, 'signing.verificationCode')

export const didSendFirstSms = (state: ReduxState): boolean =>
  get(state, 'signing.didSendFirstSms', false)

export const getSigningType = (state: ReduxState): SigningType => get(state, 'signing.type')
